// services/dialogService.js
import { createApp, ref } from 'vue'
import ElementPlus from "element-plus";

export function useDialog() {
  const openDialog = (component, props = {}) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    const app = createApp(component, {
      ...props,
      onClose: () => closeDialog()
    })

    app.use(ElementPlus)

    const closeDialog = () => {
      app.unmount()
      container.remove()
    }

    app.mount(container)

    return closeDialog
  }

  return {
    openDialog
  }
}
